"use strict";
const ALLOCATION_TARGET = 100;
const ALLOCATION_TOLERANCE = 0.05;
function roundAllocation(value) {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.round(value * 100) / 100;
}
export function clampAllocation(value) {
  return roundAllocation(Math.min(ALLOCATION_TARGET, Math.max(0, Number.isFinite(value) ? value : 0)));
}
export function sumAllocations(percentages) {
  return roundAllocation(percentages.reduce((total, percentage) => total + (percentage || 0), 0));
}
export function isAllocationComplete(total) {
  return Math.abs(total - ALLOCATION_TARGET) < ALLOCATION_TOLERANCE;
}
export function isAllocationOverTarget(total) {
  return total - ALLOCATION_TARGET >= ALLOCATION_TOLERANCE;
}
export function remainingAllocation(total) {
  return roundAllocation(Math.max(0, ALLOCATION_TARGET - total));
}
function distributeWholeAmount(amount, count) {
  if (count <= 0) {
    return [];
  }
  const whole = Number.isFinite(amount) ? Math.max(0, Math.floor(amount)) : 0;
  const base = Math.floor(whole / count);
  const remainder = whole - base * count;
  return Array.from({ length: count }, (_, index) => index < remainder ? base + 1 : base);
}
export function splitAllocationEvenly(count) {
  return distributeWholeAmount(ALLOCATION_TARGET, count);
}
export function distributeAllocationAmount(amount, count) {
  if (count <= 0 || !Number.isFinite(amount) || amount <= 0) {
    return Array.from({ length: Math.max(0, count) }, () => 0);
  }
  const shares = distributeWholeAmount(amount, count);
  const fraction = roundAllocation(amount - Math.floor(amount));
  if (fraction > 0) {
    shares[0] = roundAllocation(shares[0] + fraction);
  }
  return shares;
}
export function exceedsAllocationTarget(value) {
  return Number.isFinite(value) && value > ALLOCATION_TARGET;
}
export function formatAllocation(value) {
  return String(roundAllocation(value));
}
